// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Campaign planner */
.BC-Page__CampaignPlanner .Polaris-Page-Header {
  padding-bottom: 0;
}

.BC-Page__CampaignPlanner .Polaris-DisplayText.Polaris-DisplayText--sizeSmall {
  font-weight: 600;
  font-size: 16px;
  margin-top: 16px;
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Content {
  margin-top: 4px
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Image {
  width: 160px;
  height: 100px;
  margin: 0 auto;
}

.BC-Page__CampaignPlanner .Polaris-EmptyState__Actions .Polaris-Button__Text {
  font-weight: 500;
}

/* List/Calendar view toggle */
.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle {
  display: flex;
  width: fit-content;
  padding: 4px;
  background: #edeeef;
  border-radius: 4px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);
  margin: 24px 0;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment {
  width: 85px;
  padding: 6px 12px;
  border: none;
  background: transparent;
  color: #202223;
  font-size: 14px;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  border-radius: 4px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment--active {
  background: #fff;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08), inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);
}

/* Campaign table */
.BC-Page__CampaignPlanner .BC-Filters .BC-Filters-ConnectedFilterControl {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  padding-bottom: 0;
  border-bottom: var(--p-border-divider);
}

.BC-Page__CampaignPlanner .BC-Filters .Polaris-Tabs__Wrapper {
  border-bottom: none;
  padding: 0;
}

.BC-Page__CampaignPlanner .BC-Filters .search {
  width: 300px;
}

.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__LeftContainer {
  flex: 1 1 auto;
}

.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__RightContainer {
  flex: 1 1 auto;
  display: flex;
  align-items: center;
  justify-content: end;
}

.BC-Page__CampaignPlanner .Polaris-DataTable {
  padding: 20px;
}

.BC-Page__CampaignPlanner .Polaris-DataTable thead {
  background: #FAFBFB;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header {
  padding: 12px 16px;
  border-top: 1px solid #E1E3E5;
  font-weight: 600;
  color: #6D7175;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:first-child {
  border-top-left-radius: 8px;
  border-bottom-left-radius: 8px;
  border-left: 1px solid #E1E3E5;
  width: 215px;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:last-child {
  border-top-right-radius: 8px;
  border-bottom-right-radius: 8px;
  border-right: 1px solid #E1E3E5;
  width: 135px;
  text-align: center;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {
  vertical-align: middle;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child {
  text-align: center;
}

.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Button--outline {
  border-color: #008060;
  color: #008060;
  padding: 5px 12px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CampaignLink {
  color: #2c6ecb;
  font-size: 14px;
  font-weight: 400;
  text-decoration: none;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcons {
  display: flex;
  align-items: center;
  gap: 8px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon {
  display: inline-flex;
  width: 20px;
  height: 20px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-DateCell__Time {
  color: #6d7175;
  font-size: 12px;
}

.BC-CampaignPlanner-FeatureIconTooltip {
  background-color: #fff !important;
  border-radius: 4px;
  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;
  padding: 4px 8px !important;
  color: #202223 !important;
}

.BC-CampaignPlanner-FeatureIconTooltip::before,
.BC-CampaignPlanner-FeatureIconTooltip::after {
  display: none;
}

.BC-Page__CampaignPlanner .actionsGroup {
  text-align: right;
  margin-top: 24px;
}

.BC-CampaignPlanner-Loading {
  padding: 20px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  padding: 80px 20px;
  text-align: center;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Text {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Heading {
  font-size: 16px;
  font-weight: 600;
  color: #202223;
}

.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Body {
  font-size: 14px;
  color: #6d7175;
}

/* Campaign planner - create campaign wizard */
.BC-Page__CampaignPlannerNew .content {
  max-width: 800px;
  margin: 32px auto;
  padding: 0 20px;
}

.BC-CampaignPlannerNew-ScheduleOptions {
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin-top: 8px;
}

.BC-CampaignPlannerNew-ScheduleFields {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  margin-top: 16px;
  padding: 16px;
  background: #f6f6f7;
  border-radius: 8px;
}

@media (max-width: 768px) {
  .BC-CampaignPlannerNew-ScheduleFields {
    grid-template-columns: repeat(2, 1fr);
  }
}`, "",{"version":3,"sources":["webpack://./src/styles/campaign-planner.css"],"names":[],"mappings":"AAAA,qBAAqB;AACrB;EACE,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;AACF;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,2FAA2F;AAC7F;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iCAAiC;EACjC,kBAAkB;EAClB,iEAAiE;EACjE,2BAA2B;EAC3B,yBAAyB;AAC3B;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF","sourcesContent":["/* Campaign planner */\n.BC-Page__CampaignPlanner .Polaris-Page-Header {\n  padding-bottom: 0;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DisplayText.Polaris-DisplayText--sizeSmall {\n  font-weight: 600;\n  font-size: 16px;\n  margin-top: 16px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Content {\n  margin-top: 4px\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Image {\n  width: 160px;\n  height: 100px;\n  margin: 0 auto;\n}\n\n.BC-Page__CampaignPlanner .Polaris-EmptyState__Actions .Polaris-Button__Text {\n  font-weight: 500;\n}\n\n/* List/Calendar view toggle */\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle {\n  display: flex;\n  width: fit-content;\n  padding: 4px;\n  background: #edeeef;\n  border-radius: 4px;\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.05);\n  margin: 24px 0;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment {\n  width: 85px;\n  padding: 6px 12px;\n  border: none;\n  background: transparent;\n  color: #202223;\n  font-size: 14px;\n  font-weight: 500;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 4px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-ViewToggle__Segment--active {\n  background: #fff;\n  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.08), inset 0px -1px 0px 0px rgba(0, 0, 0, 0.08);\n}\n\n/* Campaign table */\n.BC-Page__CampaignPlanner .BC-Filters .BC-Filters-ConnectedFilterControl {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 20px;\n  padding-bottom: 0;\n  border-bottom: var(--p-border-divider);\n}\n\n.BC-Page__CampaignPlanner .BC-Filters .Polaris-Tabs__Wrapper {\n  border-bottom: none;\n  padding: 0;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters .search {\n  width: 300px;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__LeftContainer {\n  flex: 1 1 auto;\n}\n\n.BC-Page__CampaignPlanner .BC-Filters-ConnectedFilterControl__RightContainer {\n  flex: 1 1 auto;\n  display: flex;\n  align-items: center;\n  justify-content: end;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable {\n  padding: 20px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable thead {\n  background: #FAFBFB;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header {\n  padding: 12px 16px;\n  border-top: 1px solid #E1E3E5;\n  font-weight: 600;\n  color: #6D7175;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:first-child {\n  border-top-left-radius: 8px;\n  border-bottom-left-radius: 8px;\n  border-left: 1px solid #E1E3E5;\n  width: 215px;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__Cell--header:last-child {\n  border-top-right-radius: 8px;\n  border-bottom-right-radius: 8px;\n  border-right: 1px solid #E1E3E5;\n  width: 135px;\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell {\n  vertical-align: middle;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child {\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .Polaris-DataTable__Table .Polaris-DataTable__TableRow .Polaris-DataTable__Cell:last-child .Polaris-Button--outline {\n  border-color: #008060;\n  color: #008060;\n  padding: 5px 12px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CampaignLink {\n  color: #2c6ecb;\n  font-size: 14px;\n  font-weight: 400;\n  text-decoration: none;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcons {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-FeatureIcon {\n  display: inline-flex;\n  width: 20px;\n  height: 20px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-DateCell__Time {\n  color: #6d7175;\n  font-size: 12px;\n}\n\n.BC-CampaignPlanner-FeatureIconTooltip {\n  background-color: #fff !important;\n  border-radius: 4px;\n  box-shadow: 0px 2px 10px 0px #0000001A, 0px 0px 2px 0px #00000033;\n  padding: 4px 8px !important;\n  color: #202223 !important;\n}\n\n.BC-CampaignPlanner-FeatureIconTooltip::before,\n.BC-CampaignPlanner-FeatureIconTooltip::after {\n  display: none;\n}\n\n.BC-Page__CampaignPlanner .actionsGroup {\n  text-align: right;\n  margin-top: 24px;\n}\n\n.BC-CampaignPlanner-Loading {\n  padding: 20px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  padding: 80px 20px;\n  text-align: center;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Text {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 4px;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Heading {\n  font-size: 16px;\n  font-weight: 600;\n  color: #202223;\n}\n\n.BC-Page__CampaignPlanner .BC-CampaignPlanner-CompactEmptyState__Body {\n  font-size: 14px;\n  color: #6d7175;\n}\n\n/* Campaign planner - create campaign wizard */\n.BC-Page__CampaignPlannerNew .content {\n  max-width: 800px;\n  margin: 32px auto;\n  padding: 0 20px;\n}\n\n.BC-CampaignPlannerNew-ScheduleOptions {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  margin-top: 8px;\n}\n\n.BC-CampaignPlannerNew-ScheduleFields {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 12px;\n  margin-top: 16px;\n  padding: 16px;\n  background: #f6f6f7;\n  border-radius: 8px;\n}\n\n@media (max-width: 768px) {\n  .BC-CampaignPlannerNew-ScheduleFields {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
